import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from './../../forms/button/button.module';
import { HeaderSlimComponent } from './header-slim.component';

@NgModule({
  declarations: [HeaderSlimComponent],
  imports: [CommonModule, ButtonModule],
  exports: [HeaderSlimComponent]
})
export class HeaderSlimModule {}
